module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-nav",
    class: _vm.className
  }, [_c('v-touch', {
    on: {
      "tap": _vm.prev,
      "doubletap": _vm.preventZoom
    }
  }, [_c('div', {
    staticClass: "icon-arrow-left4 no-print left-button"
  })]), _vm._v(" "), _c('v-touch', {
    staticClass: "today-button",
    class: {
      notActive: !_vm.isNotToday
    },
    on: {
      "tap": function($event) {
        return _vm.$emit('today')
      }
    }
  }, [_c('div', {
    staticClass: "center-button"
  }, [_vm._v(_vm._s(_vm.$t('repitition.today')))])]), _vm._v(" "), _c('v-touch', {
    on: {
      "tap": _vm.next
    }
  }, [_c('div', {
    staticClass: "icon-arrow-right4 no-print right-button"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7967a35a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/Mobile/FooterNav.vue
// module id = 2027
// module chunks = 1